import React from 'react'
import { NavLink } from 'react-router-dom'
import './style.scss';

function AppCTA(props) {
    return (
        <>
            <NavLink to={props.url} className="cta-footer common-transition">
                <div className='d-flex'>
                    {props.title}
                    <span className='footer-link-space'> <i className="bi bi-arrow-right"></i></span>
                </div>
            </NavLink>
        </>
    )
}
AppCTA.WithWhiteHover = (props) => {
    return (
        <>
            <NavLink to={props.url} className="cta-link-yellow common-transition">
                <div className='d-flex'>
                    <div>
                        {props.title}
                        <span className='link-space'> <i className="bi bi-arrow-right"></i></span>
                    </div>
                </div>
            </NavLink>
        </>
    )
}

AppCTA.WithEnergyPurple = (props) => {
    return (
        <>
            <NavLink to={props.url} className="cta-link-purple common-transition">
                <div className='d-flex'>                 
                        {props.title}
                        <span className='link-space'> <i className="bi bi-arrow-right"></i></span>
                </div>
            </NavLink>
        </>
    )
}
export default AppCTA